import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-tag-roles',
  templateUrl: './tag-roles.component.html',
  styleUrls: ['./tag-roles.component.scss'],
})
export class TagRolesComponent {

  
  loader: boolean = false;
  edit: boolean = false;
  id;
  url;
  item;
  firstName;
  contactNbrMob;
  emailId;
  overAllRoles:any=[];
  userRoles:any=[];
  userPostRoles:any=[];

  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
     public santinzer: DomSanitizer,
      public platform: Platform) { }

      ionViewWillEnter(){
        this.url = window.location.href;
        this.id = this.url.split('/').pop();
        this.loader = true;
        this.getRoles()
      }
    
      getRoles(){
        this.loader = true;
        this.service.getAssociateRoles().subscribe(res =>{
          if (res) {
            this.overAllRoles = res; 
                    this.loader = false;     
            this.overAllRoles.map(res=>{
              Object.assign(res,{select:false})
            })
            this.getUserData()
          }
        })
      }
    
      select(id){
        this.overAllRoles.map(res=>{
          if(res.roleId == id){
            res.select=!res.select;
          }
        })
        this.userRoles=this.userRoles.filter(res=>res.roleId!=id)
      }
      save(){
        this.userPostRoles=this.overAllRoles.filter(res=>{return res.select==true });
        this.userPostRoles=this.userPostRoles.concat(this.userRoles)
        this.userPostRoles = this.userPostRoles.filter((v, i, a) => a.findIndex(t => (t.roleId === v.roleId)) === i);
        let post:any=[];
        this.userPostRoles.map(res=>{
          post.push({roleId:res.roleId})
    
        })
        this.service.postAssociateRoles(this.id,post).subscribe((res: any) => {
          this.loader = false;
          this.handler.res("Roles Updated Successfully");
          if(this.url.includes('cust-role-tag')){
            this.router.navigate(['/customer']);
          }else{
            this.router.navigate(['/user']);
          }
       
        },
          err => {
            this.loader = false;
            this.handler.err(err.error);
          })
    
      }
      getUserData(){
        this.service.getAddressById(this.id).subscribe((res: any) =>{
          this.item = res;
          this.firstName = res.firstName;
          this.contactNbrMob = res.contactNbrMob;
          this.emailId = res.emailId;
          this.loader=false;
          this.userRoles = res.roles;
          this.overAllRoles.map(res3=>{
            this.userRoles.map(res1=>{
              if(res3.roleId==res1.roleId){
                res3.select=true;
              }
            })
          })
     },
     err=>{
       this.loader=false;
       this.handler.err(err)
     })
      }
      ionViewWillLeave(){
        sessionStorage.removeItem('orgId');
      }
}
